module.exports = __webpack_public_path__ + "img/10.b263b698.png";